module.exports = __webpack_public_path__ + "media/images/guk50-f4397a9f.png";